import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import CreateReport from '../../containers/reports/CreateReport'
import APageHeader from '../../components/atoms/APageHeader'

class PReportCreate extends React.Component<RouteComponentProps<{  customerId: string}>> {
    render() {
        const {  customerId } = this.props.match.params
        const back = `/admin/customers/${customerId}`
        return (
            <React.Fragment>
                <APageHeader>Add a new report</APageHeader>
                <CreateReport
                    id = {customerId}
                    back={back}
                    onSuccess={() => this.props.history.push(back)}
                />
            </React.Fragment>
        )
    }
}

export default PReportCreate
